const MAIN_SCROLL_ID = "app-main-content";

export function obterIdScrollPrincipal() {
  return MAIN_SCROLL_ID;
}

export function rolarPrincipalParaTopo(comportamento: ScrollBehavior = "auto") {
  if (typeof document === "undefined") return;

  const principal = document.getElementById(MAIN_SCROLL_ID);
  if (principal instanceof HTMLElement) {
    principal.scrollTo({ top: 0, behavior: comportamento });
    return;
  }

  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, behavior: comportamento });
  }
}
